// Human-friendly date/time formatting for tables and detail views.
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function parse(value) {
  if (!value) return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

const pad = (n) => String(n).padStart(2, "0");

// e.g. "25 Sep 2026"
export function formatDate(value) {
  const d = parse(value);
  if (!d) return "—";
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

// e.g. "25 Sep 2026, 14:35"
export function formatDateTime(value) {
  const d = parse(value);
  if (!d) return "—";
  return `${formatDate(value)}, ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
